var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),_c('a',{staticClass:"back-btn",attrs:{"href":_vm.langingURL}}),_c('a',{staticClass:"kefu-btn",attrs:{"href":"https://bjsqxwhyxgs.qiyukf.com/client?k=31376a2d5639328d871def1a93bb6ced&wp=1"}}),_c('footer',{staticClass:"footer"},[_vm._v("SKF 斯凯孚 @2020")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }